/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 2/5/14
 * Time: 10:29 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-edit/canned/hotKeysCanned.tmpl");
    var Dropdown = require("ui/dropdown/Dropdown");
    var Button = require("ui/button/Button");
    var ValidationUtilities = require("utils/ValidationUtilities");
    var ErrorCodes = require("codeTables/errorCodes.json");

    var KEYS = {
        RESET: "resetSelection"
    };

    var HotKeysCannedView = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        HotKeysCannedView = Marionette.ItemView.extend({
            template:  template,
            className: "hot-keys",

            ui: {
                leftDropDown: ".left-dropdown-container",
                rightDropDown: ".right-dropdown-container"
            },
            uiComponents: {
                letterSelection: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.leftDropDown",
                        permutation: Dropdown.PERMUTATION.XXX_SMALL1,
                        placeholder: LE.translator.translate("LEContent.content.edit.hotkeys.letter.selection.placeholder"),
                        testCollision: true,
                        items : "view._getHotKeysLetterCollection"
                    },
                    events: {
                        "change": "_letterSelectionChanged"
                    }

                },
                numberSelection: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.rightDropDown",
                        permutation: Dropdown.PERMUTATION.XXX_SMALL1,
                        placeholder: LE.translator.translate("LEContent.content.edit.hotkeys.number.selection.placeholder"),
                        enabled: false,
                        testCollision: true ,
                        items: "view._getHotKeysNumberCollection"
                    },
                    events: {
                        "change": "_numberSelectionChanged"
                    }
                }
            },
            validationSettings: {
                numberSelection: {
                    uiKey: "numberSelection",
                    errKeys: ["hotkey.suffix"],
                    uiType: "uiComponents"
                }
            },
            _invalid: function(model, errors) {
                LEContent.logger.info("on Invalid called", "HotKeysCannedView:onInvalid");
                ValidationUtilities.setValidationErrors(this,false,this.contentModel);
            },
            _error: function(model, resp, options) {
                LEContent.logger.info("on error called", "HotKeysCannedView:onError");
                if(resp && resp.responseError && resp.responseError.internalCode == ErrorCodes.uniquenessViolation){
                    var errorMsg = LE.translator.translate("LEContent.content.edit.errors.hotkeys.taken.msg");
                    this.uiComponents.letterSelection.setError(true, errorMsg);
                    this.uiComponents.numberSelection.setError(true, errorMsg);
                }
            },
            _clearErrors: function(){
                this.uiComponents.letterSelection.setError(false);
                this.uiComponents.numberSelection.setError(false);
            },
            initialize: function (options) {
                LEContent.logger.debug("Initializing HotKeysCannedView", "HotKeysCannedView:initialize");
                this.channel = options.channel;
                this.model = options.model;
                this.contentModel = this.model.getContentModel();
                this.bindEvents();
            },
            bindEvents: function () {
                this.listenTo(this.model,"change:model",this._updateViewWithChangedModel,this);
                this.bindContentModelEvents();
            },
            bindContentModelEvents: function () {
                this.listenTo(this.contentModel,"invalid",this._invalid);
                this.listenTo(this.contentModel,"error",this._error);
            },
            _updateViewWithChangedModel: function() {
                this._clearErrors();
                this.stopListening(this.contentModel);
                this.contentModel = this.model.getContentModel();
                this._generateHotKeys();
                this.bindContentModelEvents();
            },
            onBeforeRender: function () {
                LEContent.logger.debug("onBeforeRender HotKeysCannedView", "HotKeysCannedView:onBeforeRender");
            },
            onRender: function () {
                LEContent.logger.debug("onRender HotKeysCannedView", "HotKeysCannedView:onRender");

                if(!_.isEmpty(this._getContentHotKeys())){
                    this.setHoyKeysSelection();
                }
            },
            setHoyKeysSelection: function(){
                var contentHotKeys = this._getContentHotKeys();
                if(!_.isEmpty(contentHotKeys)){
                    this.uiComponents.letterSelection.setSelection(contentHotKeys.prefix);
                    this.uiComponents.numberSelection.setSelection(contentHotKeys.suffix);
                    this.uiComponents.numberSelection.setEnabled(true);
                }
                else{
                    this._resetHotKeysSelection();
                }
            },
            _getContentHotKeys: function(){
                return this.model.getContentHotKeys();
            },
            _resetHotKeysSelection: function(){
                this.uiComponents.letterSelection.setSelection(null);
                this.uiComponents.numberSelection.setSelection(null);
                this.uiComponents.numberSelection.setEnabled(false);
                this._hotKeysSelectedEvent();
            },
            _letterSelectionChanged: function (componentId, eventName, value){
                if(value.selectedKey === KEYS.RESET){
                    this._resetHotKeysSelection();
                }
                else{
                    this.uiComponents.numberSelection.setSelection(null);
                    this._setHotKeysNumberCollectionItems();
                    this._hotKeysSelectedEvent();
                }
            },
            _numberSelectionChanged: function (componentId, eventName, value){
                this._clearErrors();
                this._hotKeysSelectedEvent();
            },
            _getHotKeysLetterCollection: function(){
                var letterCollectionItems = new Dropdown.Collection();

                var contentHotKeys = this._getContentHotKeys();
                var availableLetters = this.model.getAvailableLetterHotKeys(_.isEmpty(contentHotKeys) ? null : contentHotKeys.prefix);

                letterCollectionItems.push({key: KEYS.RESET, value: "-"});
                _.each(availableLetters, function(letter) {
                    letterCollectionItems.push({key: letter, value: letter.toUpperCase()});
                });

                return letterCollectionItems;
            },
            _getHotKeysNumberCollection: function(){
                var numbersCollectionItems = new Dropdown.Collection();
                var selectedLetter = this.uiComponents.letterSelection.getValue();
                var letterInModel = _.isEmpty(this._getContentHotKeys()) ? null : this._getContentHotKeys().prefix;
                var letter = selectedLetter || letterInModel;
                var contentHotKeys = this._getContentHotKeys();
                var availableNumbers = this.model.getAvailableNumberHotKeys(letter, _.isEmpty(contentHotKeys) ? null : (_.isEmpty(contentHotKeys.suffix) || contentHotKeys.prefix !== letter) ? null : parseInt(contentHotKeys.suffix, 10));
                _.each(availableNumbers, function(number){
                    numbersCollectionItems.push({key: ''+number, value: number});
                });
                return numbersCollectionItems;
            },
            _setHotKeysLetterCollectionItems: function(){
                var lettersCollectionItems = this._getHotKeysLetterCollection();
                this.uiComponents.letterSelection.setSelection(null);
                this.uiComponents.letterSelection.setItems(lettersCollectionItems);
            },
            _setHotKeysNumberCollectionItems: function(){
                var numbersCollectionItems = this._getHotKeysNumberCollection();

                this.uiComponents.numberSelection.setSelection(null);
                this.uiComponents.numberSelection.setItems(numbersCollectionItems);
                this.uiComponents.numberSelection.setEnabled(true);
            },
            _generateHotKeys: function(){
                this.contentModel = this.model.getContentModel();
                this._setHotKeysLetterCollectionItems();
                this._setHotKeysNumberCollectionItems();
                this.setHoyKeysSelection();
            },
            _hotKeysSelectedEvent: function(){
                this.channel.trigger("hotKeysCannedView:hotkeys:change", {"prefix": this.uiComponents.letterSelection.getValue(), "suffix": this.uiComponents.numberSelection.getValue()});
            },

            onClose: function () {
                LEContent.logger.debug("onClose HotKeysCannedView", "HotKeysCannedView:onClose");
            }
        });

    });
    return HotKeysCannedView;
});
